import React, { useState } from 'react';
import Layout from '../components/Layout';
import PageHero from '../components/PageHero';
import ContactCTA from '../components/ContactCTA';
import SEO from '../components/SEO';
import { combineSchemas, organizationSchema, breadcrumbSchema } from '../lib/schema';
import { portfolioProjects } from '../mock';
import { ArrowRight } from 'lucide-react';

const categories = ['All', 'eCommerce', 'Corporate', 'Portfolio', 'Service'];

const tagMap = {
  'eCommerce': ['Fashion eCommerce', 'Tour Booking'],
  'Corporate': ['Custom Truss Manufacturing', 'Roadracing Association'],
  'Portfolio': ['Fine Art Gallery'],
  'Service': ['Private Investigation', 'Cabin Rentals', 'Flooring & Paving', 'Spiritual Products'],
};

const PortfolioPage = () => {
  const [active, setActive] = useState('All');

  const filtered = active === 'All'
    ? portfolioProjects
    : portfolioProjects.filter((p) => (tagMap[active] || []).includes(p.tag));

  return (
    <Layout>
      <SEO
        title="Web Design Portfolio | Recent Projects | Website Symphony"
        description="Browse recent websites designed and developed by Website Symphony including eCommerce, corporate, service and portfolio sites across the U.S."
        canonical="/portfolio"
        schema={combineSchemas(organizationSchema, breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Portfolio', path: '/portfolio' }]))}
      />
      <PageHero title="Our Portfolio" subtitle="A selection of recent website design and development projects from the Website Symphony team." breadcrumb="Portfolio" />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`px-5 py-2 rounded-full font-medium text-sm transition-colors ${
                  active === c ? 'bg-[#2C5F66] text-white' : 'bg-[#F7F7F5] text-[#2C5F66] hover:bg-[#2C5F66]/10'
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {filtered.map((proj) => (
              <article key={proj.name} className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
                <div className="overflow-hidden h-52">
                  <img src={proj.image} alt={proj.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                </div>
                <div className="p-6">
                  <span className="text-[#D9A04A] text-xs font-semibold tracking-wider uppercase">{proj.tag}</span>
                  <h4 className="mt-2 text-[#2C5F66] text-xl font-bold leading-tight group-hover:text-[#D9A04A] transition-colors">{proj.name}</h4>
                  <p className="mt-3 text-gray-600 text-sm leading-relaxed line-clamp-3">{proj.description}</p>
                  <a href="#" className="mt-4 inline-flex items-center gap-1 text-[#2C5F66] font-semibold text-sm hover:text-[#D9A04A] transition-colors">
                    View Case Study <ArrowRight size={14} />
                  </a>
                </div>
              </article>
            ))}
          </div>

          {filtered.length === 0 && (
            <p className="text-center text-gray-500 py-12">No projects in this category yet.</p>
          )}
        </div>
      </section>

      <ContactCTA defaultService="Portfolio Inquiry" heading="Have a project in mind?" subheading="Let’s build something beautiful together." />
    </Layout>
  );
};

export default PortfolioPage;
